// localStorage keys and ids
export const WEB3_CONNECT_MODAL_ID = "WEB3_CONNECT_MODAL_ID";
export const INJECTED_PROVIDER_ID = "injected";
export const CACHED_PROVIDER_KEY = "WEB3_CONNECT_CACHED_PROVIDER";

// Core events

export const CONNECT_EVENT = "connect";
export const ERROR_EVENT = "error";
export const CLOSE_EVENT = "close";

// CSS ClassNames

export const MODAL_LIGHTBOX_CLASSNAME = "web3connect-modal-lightbox";
export const MODAL_CONTAINER_CLASSNAME = "web3connect-modal-container";
export const MODAL_HITBOX_CLASSNAME = "web3connect-modal-hitbox";
export const MODAL_CARD_CLASSNAME = "web3connect-modal-card";

export const PROVIDER_WRAPPER_CLASSNAME = "web3connect-provider-wrapper";
export const PROVIDER_CONTAINER_CLASSNAME = "web3connect-provider-container";
export const PROVIDER_ICON_CLASSNAME = "web3connect-provider-icon";
export const PROVIDER_NAME_CLASSNAME = "web3connect-provider-name";
export const PROVIDER_DESCRIPTION_CLASSNAME =
  "web3connect-provider-description";

export const CONNECT_BUTTON_CLASSNAME = "web3connect-connect-button";
